//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TelephoneInformationDisplayItem } from './TelephoneInformationDisplayItem';
import { TeacherCalendarPreferencesDisplayItem } from './TeacherCalendarPreferencesDisplayItem';
import { TeacherCalendarFeedPreferencesDisplayItem } from './TeacherCalendarFeedPreferencesDisplayItem';
import { TeacherEmailPreferencesDisplayItem } from './TeacherEmailPreferencesDisplayItem';
import { TeacherAttendancePreferencesDisplayItem } from './TeacherAttendancePreferencesDisplayItem';
import { TeacherNavigationPreferencesDisplayItem } from './TeacherNavigationPreferencesDisplayItem';
import { LanguageDisplayItem } from './LanguageDisplayItem';
import { UserInfoDisplayItem } from './UserInfoDisplayItem';
import { InvoiceFormat } from './Enums';

export class TeacherProfileDisplayItem extends UserInfoDisplayItem {
    Address: string | null = null;
    Subjects: string[] = [];     // OBSOLETE - Use only for compatibility
    Telephone: TelephoneInformationDisplayItem | null = null;
    Title: string | null = null;
    ZoomMeetingURL: string | null = null;
    ShowSetupGuide: boolean = false;
    CalendarPreferences: TeacherCalendarPreferencesDisplayItem | null = null;
    CalendarFeedPreferences: TeacherCalendarFeedPreferencesDisplayItem | null = null;
    EmailPreferences: TeacherEmailPreferencesDisplayItem | null = null;
    AttendancePreferences: TeacherAttendancePreferencesDisplayItem | null = null;
    NavigationPreferences: TeacherNavigationPreferencesDisplayItem | null = null;
    InvoiceFormatPreference: InvoiceFormat = InvoiceFormat.Normal;
    TimeZoneID: string | null = null;
    SpokenLanguages: LanguageDisplayItem[] = [];

    constructor(initializer?: Partial<TeacherProfileDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "TeacherProfileDisplayItem";
}
